<template>
    <div class="wrap-learning-task">
        <div class="item-learning-task">
            <div class="wrap-task-child indented">
                <div @click="handViewLearningTask(item)" class="task-child-item"
                    v-for="(item, index) of listLearningTaskLesson" :key="index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <ModalViewLearningTask :learningTaskId="learningTaskId" :listQuestion="listQuestion"
            v-if="isOpenModalModalViewLearningTask" @closeModal="closeModalViewLearningTask" />
    </div>
</template>
<script>
import { getListLearningTaskLesson, getListQuestion } from './../../../_api/learningTask'
import ModalViewLearningTask from './../../../_components/ModalViewLearningTask'

export default {
    components: {
        ModalViewLearningTask
    },
    data() {
        return {
            listQuestion: [],
            isOpenModalModalViewLearningTask: false,
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                subjectId: 0,
                classId: 0
            },
            totalRecords: 0,
            learningTaskId: 0,
            listLearningTaskLesson: [],
        }
    },
    mounted() {
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.getListLearningTask()
    },
    methods: {
        closeModalViewLearningTask() {
            this.isOpenModalModalViewLearningTask = false
        },
        getListQuestionByLearningTask(item) {
            let self = this
            let params = {
                lessonClassSchoolId: this.$route.query.id,
                classSchoolId: 0,
                learningTaskId: item.learningTaskId
            }
            getListQuestion(params).then(res => {
                if (res && res.data && !res.errors) {
                    self.listQuestion = res.data
                }
                this.isOpenModalModalViewLearningTask = true
            })

        },
        handViewLearningTask(item) {
            this.learningTaskId = item.id
            this.getListQuestionByLearningTask(item)

        },
        getListLearningTask() {
            let self = this
            getListLearningTaskLesson(self.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLearningTaskLesson = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.task-child-item {
    color: blue;
    cursor: pointer;
}
</style>